import { TrimType } from '../../../../types';
import CarCalculation from '../utils/car';

export interface CalcModel {
  calculator_cars: Array<CalcCar>;
  id: number;
  name: string;
}

export type CalcCar = Pick<
  TrimType,
  'id' | 'name' | 'code' | 'model_id' | 'image'
>;
export enum TypeOfLeasing {
  BUSINESS = 'Kia Business Lease⁵⁾',
  FINANCIAL = 'Kia Finansiell Leasing⁶⁾',
}

export type FuelType = 'el' | 'bensin' | 'hybrid' | 'laddhybrid';

export type CarWithCalculation = {
  car: TrimType | null;
  calc: CarCalculation | null;
};

export type Mileage = 1500 | 2000 | 3000 | 4000;

declare global {
  interface Window {
    dataLayer: Record<string, any>[];
  }
}
